<template>
    <div class="row justify-content-center">
        <div class="col-lg-12 text-center">
            <p>Logging out...</p>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'login',
    data() {
      return {
        isLoading: false,
        error_message: false,
        model: {
          username: '',
          password: ''
        }
      }
    },
    methods: {
        executeLogout() {
            this.$http.post('/api/logout')
            .then(() => {
              localStorage.clear();
              this.$router.push('login');
              location.href = '/project/login';
            })
            .catch((error) => {
              console.log(error);
              localStorage.clear();
              this.$router.push('login');
              location.href = '/project/login';
            });
        }
    },
    beforeMount(){
        this.executeLogout()
    }
  }
</script>
<style>
</style>
